import { authFetch } from 'shared/api/authFetch';
import { config } from 'shared/config/config';

const requestJson = async (path, options = {}) => {
  const response = await authFetch(`${config.API_URL}${path}`, options);
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const detail = payload?.detail;
    const message =
      typeof detail === 'string'
        ? detail
        : detail?.message ||
          (Array.isArray(detail)
            ? detail.map((item) => item?.msg || String(item)).join('; ')
            : null);
    throw new Error(message || `Agent request failed (${response.status})`);
  }
  return payload;
};

export const listInitiatives = (ownerAgentId = null) => {
  const suffix = ownerAgentId
    ? `?owner_agent_id=${encodeURIComponent(ownerAgentId)}`
    : '';
  return requestJson(`/api/initiatives${suffix}`);
};
export const getInitiative = (initiativeId) =>
  requestJson(`/api/initiatives/${encodeURIComponent(initiativeId)}`);
export const getInitiativeConversation = (initiativeId, cursor = null) => {
  const suffix = cursor ? `?cursor=${encodeURIComponent(cursor)}` : '';
  return requestJson(`/api/initiatives/${encodeURIComponent(initiativeId)}/conversation${suffix}`);
};
export const getInitiativeConfiguration = (initiativeId) =>
  requestJson(`/api/initiatives/${encodeURIComponent(initiativeId)}/configuration`);
export const updateInitiativeConfiguration = (initiativeId, payload) =>
  requestJson(`/api/initiatives/${encodeURIComponent(initiativeId)}/configuration`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
export const updateInitiativeLlm = (initiativeId, payload) =>
  requestJson(`/api/initiatives/${encodeURIComponent(initiativeId)}/llm`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
export const getInitiativeWakeRules = (initiativeId) =>
  requestJson(`/api/initiatives/${encodeURIComponent(initiativeId)}/wake-rules`);
export const createInitiativeWakeRule = (initiativeId, payload) =>
  requestJson(`/api/initiatives/${encodeURIComponent(initiativeId)}/wake-rules`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
export const updateInitiativeWakeRule = (initiativeId, ruleId, payload) =>
  requestJson(
    `/api/initiatives/${encodeURIComponent(initiativeId)}/wake-rules/${encodeURIComponent(ruleId)}`,
    { method: 'PATCH', body: JSON.stringify(payload) }
  );
export const deleteInitiativeWakeRule = (initiativeId, ruleId) =>
  requestJson(
    `/api/initiatives/${encodeURIComponent(initiativeId)}/wake-rules/${encodeURIComponent(ruleId)}`,
    { method: 'DELETE' }
  );
export const validateInitiativeWakeRule = (initiativeId, payload) =>
  requestJson(`/api/initiatives/${encodeURIComponent(initiativeId)}/wake-rules/validate`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
export const wakeInitiativeNow = (initiativeId) =>
  requestJson(`/api/initiatives/${encodeURIComponent(initiativeId)}/wake-now`, {
    method: 'POST',
  });
export const createInitiativeDraft = (payload) =>
  requestJson('/api/initiatives', { method: 'POST', body: JSON.stringify(payload) });
export const startInitiative = (initiativeId) =>
  requestJson(`/api/initiatives/${encodeURIComponent(initiativeId)}/start`, { method: 'POST' });
export const deleteInitiative = (initiativeId) =>
  requestJson(`/api/initiatives/${encodeURIComponent(initiativeId)}`, { method: 'DELETE' });
export const sendInitiativeMessage = (
  initiativeId,
  message,
  metadata = {},
  files = [],
  initiativeAskId = null,
  choice = null
) => {
  if (files.length) {
    const form = new FormData();
    form.append('message', message || 'I attached sample data for this initiative.');
    form.append('metadata', JSON.stringify(metadata || {}));
    if (initiativeAskId) form.append('initiative_ask_id', initiativeAskId);
    files.forEach((file) => form.append('files', file));
    return requestJson(
      `/api/initiatives/${encodeURIComponent(initiativeId)}/messages-with-files`,
      { method: 'POST', body: form }
    );
  }
  return requestJson(`/api/initiatives/${encodeURIComponent(initiativeId)}/messages`, {
    method: 'POST',
    body: JSON.stringify({ message, metadata, initiative_ask_id: initiativeAskId, choice }),
  });
};
export const changeInitiativeState = (initiativeId, action, reason = null) =>
  requestJson(`/api/initiatives/${encodeURIComponent(initiativeId)}/${action}`, {
    method: 'POST',
    body: JSON.stringify({ reason }),
  });
export const getInitiativeActivity = (initiativeId) =>
  requestJson(`/api/initiatives/${encodeURIComponent(initiativeId)}/activity`);

export const getInitiativeWakeTrace = (initiativeId, turnId) =>
  requestJson(
    `/api/initiatives/${encodeURIComponent(initiativeId)}/activity/${encodeURIComponent(turnId)}`
  );

export const getInitiativeActivityBeatReasoning = (initiativeId, turnId, beatIndex) =>
  requestJson(
    `/api/initiatives/${encodeURIComponent(initiativeId)}/activity/${encodeURIComponent(turnId)}/beats/${encodeURIComponent(beatIndex)}/reasoning`
  );

export const listSignals = () => requestJson('/api/admin/signals');
